import { z } from 'zod';
import { equipmentValidationPatterns, equipmentValidationMessages, } from './constants';
// Equipment validation schema
const equipmentSchema = z.object({
    assetType: z.enum(['container', 'chassis', 'trailer']),
    equipmentNumber: z.string().trim().min(1, 'Equipment number is required'),
});
// Add Leg form schema
export const addLegSchema = z.object({
    legType: z.string().min(1, 'Leg type is required'),
    equipment: z
        .array(equipmentSchema)
        .min(1, 'At least one equipment is required'),
    totalWeight: z.string().min(1, 'Total weight is required'),
    weightUnit: z.string().min(1, 'Weight unit is required'),
    pickupName: z.string().min(1, 'Pickup location name is required'),
    pickupAddress: z.string().min(1, 'Pickup address is required'),
    deliverName: z.string().min(1, 'Delivery location name is required'),
    deliverAddress: z.string().min(1, 'Delivery address is required'),
    carrier: z.string().min(1, 'Carrier is required'),
    specialInstructions: z.string().optional(),
});
// Add Hub form schema
export const addHubSchema = z.object({
    yardId: z.string().min(1, 'Yard is required'),
    hubbingType: z.enum(['Pre-Pull', 'Stop-Off', 'Yard-Diversion']),
});
// Helper function to validate equipment format and return warnings
export function validateEquipmentFormat(equipmentNumber, assetType) {
    if (!equipmentNumber)
        return null;
    const typeKey = (assetType || '').toLowerCase();
    const pattern = equipmentValidationPatterns[typeKey];
    const message = equipmentValidationMessages[typeKey];
    if (!pattern)
        return null;
    if (!pattern.test(equipmentNumber)) {
        return message;
    }
    return null;
}
